import React from "react";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  Typography,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { getLandingRoute } from "../../utils/landingRoute";
import Logo from "./Image/Qrata.svg";
import { useTheme, useMediaQuery } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ClientLogin from "../FinalTalentCard/clientLogin";
import { useModal } from "../../customHooks";
// import navItems from './NavItems';
import { useSelector } from "react-redux";
import IndiaFlag from "../../images/png/india-flag.png";
import UKFlag from "../../images/png/uk-flag.png";
import UAEFlag from "../../images/png/uae-flag.png";
import USFlag from "../../images/png/us-flag.png";
import GermanyFlag from "../../images/png/germany-flag.png";
import { currenciesWithSymbol } from "../../OptionData";

function currencyImage(currency) {
  switch (currency) {
    case "INR":
      return IndiaFlag;
    case "GBP":
      return UKFlag;
    case "AED":
      return UAEFlag;
    case "USD":
      return USFlag;
    case "EUR":
      return GermanyFlag;
  }
};

const SALES_LINKS = ['/sales', '/custom', '/public'];

const DrawerContent = ({
  role,
  setAnchorEl,
  setAnalyticsAnchorEl,
  setCurrencyAnchorEl,
  setMobileOpen,
  navItems,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
    const isAuth = useSelector(state => state.user.user.auth);
  const loginModal = useModal();

  const currentCurrency = useSelector((state) => state.user.currency);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isScreenHeightSmall = window.innerHeight <= 700;
  const iconSize = isScreenHeightSmall ? 16 : 32;
  const normalizedPath = window.location.pathname.replace(/\/$/, '').toLowerCase();
  const pathSegments = normalizedPath.split('/');
  const lastSegment = `/${pathSegments[pathSegments.length - 1]}`;
  const isSalesLink = SALES_LINKS
    .map(link => link.toLowerCase())
    .includes(lastSegment);
  const currentPath = location.pathname;
  const accountRoutes = [
    "/account-view",
    "/team-members",
    "/changepassword",
    "/client/settings",
  ];
  const analyticsRoutes = [
    "/daily-report",
    "/admin-dashboard",
    "/hiring-report",
    "/candidate-report",
    "/analytics",
  ];

  const activeLabel = accountRoutes.includes(currentPath)
    ? "Account"
    : analyticsRoutes.includes(currentPath)
      ? "Analytics"
      : navItems?.find((item) => {
          // For talent pool, check if the current path starts with the item path
          // This handles both /talent-pool and /talent-pool/:clientId
          if (item.label === 'Talent Pool') {
            return currentPath.startsWith('/talent-pool');
          }
          return item.path === currentPath;
        })?.label || "";

  const handleClick = (e, label, path) => {
    e.stopPropagation();
    if (label === "Account") {
      setAnchorEl(e.currentTarget);
    } else if (label === "Analytics" && role === "client") {
      navigate("/analytics");
      if (isMobile && setMobileOpen) {
        setMobileOpen(false);
      }
    } else if (label === "Analytics") {
      setAnalyticsAnchorEl(e.currentTarget);
    } else if (label === "Currency") {
      setCurrencyAnchorEl(e.currentTarget);
    } else {
      navigate(path);
      if (isMobile && setMobileOpen) {
        setMobileOpen(false);
      }
    }
  };

  const filteredItems =
    role === "Admin" || role === "Account Manager" || role === "client"
      ? navItems
      : navItems?.filter((item) => item.label !== "Analytics");
  return (
    <>
    <Box
      onClick={isMobile ? () => { } : undefined}
      sx={{
        textAlign: "center",
        mt: { xs: 5, sm: 0 },
        display: "flex",
        flexDirection: "column",
        height: "100%"
      }}
    >
      {!isMobile && (
        <>
          <Box
            sx={{ py: 2, cursor: "pointer" }}
            onClick={() => navigate(getLandingRoute(role))}
          >
            <img src={Logo} alt="Qrata" style={{ width: "50%" }} />
            <Typography
              style={{ color: "#504949", fontSize: "15px", fontWeight: 600 }}
            >
              Qrata
            </Typography>
          </Box>
          <Divider />
        </>
      )}

      {/* {!isAuth && (
        <Box sx={{ flex: 1 }}>
          <List>
            <ListItem sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 0 }}>
              <ListItemButton
                onClick={() => {
                  loginModal.handleChange();
                  if (isMobile && setMobileOpen) setMobileOpen(false);
                }}
                sx={{
                  flexDirection: isMobile ? "row" : "column",
                  alignItems: "center",
                  justifyContent: isMobile ? "flex-start" : "center",
                  px: isMobile ? 2 : 0,
                  textAlign: isMobile ? "left" : "center",
                  gap: isMobile ? 1.5 : 0,
                  width: "100%",
                  "&:hover": { backgroundColor: "transparent" },
                  "aria-label": "Login",
                  title: "Login",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: theme.palette.custom.primaryTextGrey,
                    width: iconSize,
                    height: iconSize,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 1,
                    flexShrink: 0,
                  }}
                >
                  <AccountCircleOutlinedIcon className="icon-size" fontSize="small" />
                </Box>
                <Box sx={{ fontSize: 12, color: theme.palette.custom.primaryTextGrey, fontWeight: 500 }}>
                  Login
                </Box>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      )} */}

{isAuth &&
  
      <Box sx={{ flex: 1 }}>
        <List>
          {filteredItems?.map(({ icon: Icon, label, path, badge }) => {
            const isSelected = activeLabel === label;
            return (
              <ListItem 
                key={label}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  p: 0,
                  // mb: 2,
                }}
              >
                <ListItemButton
                  onClick={(e) => handleClick(e, label, path)}
                  sx={{
                    position: "relative",
                    flexDirection: isMobile ? "row" : "column",
                    alignItems: "center",
                    justifyContent: isMobile ? "flex-start" : "center",
                    color: isSelected
                      ? theme.palette.custom.primaryBlue
                      : "inherit",
                    // py: 1.5,
                    paddingRight:"16px",
                    px: isMobile ? 2 : 0,
                    textAlign: isMobile ? "left" : "center",
                    // gap: 1,
                    width: "100%",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                    "aria-label": label,
                    title: label,
                    "&::after": isSelected ? {
                      content: '""',
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "2px",
                      height: "50px",
                      backgroundColor: theme.palette.custom.primaryGreen,
                    } : {},
                  }}
                >
                  <Box
                    className="new-navbar"
                    sx={{
                      backgroundColor: "transparent",
                      border: "none",
                      color: isSelected
                        ? theme.palette.custom.primaryGreen
                        : theme.palette.custom.primaryTextGrey,
                      width: iconSize,
                      height: iconSize,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 1,
                      flexShrink: 0,
                      position: "relative",
                    }}
                  >
                    <Icon className="icon-size" fontSize="small" />
                    {badge > 0 && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: -4,
                          right: -4,
                          minWidth: 16,
                          height: 16,
                          px: "3px",
                          borderRadius: "9999px",
                          backgroundColor: theme.palette.custom.primaryGreen,
                          color: theme.palette.custom.whiteBackground,
                          fontSize: 10,
                          fontWeight: 700,
                          lineHeight: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
                        }}
                      >
                        {badge}
                      </Box>
                    )}
                  </Box>

                  <Box
                    sx={{
                      fontSize: 12,
                      color: isSelected
                        ? theme.palette.custom.primaryGreen
                        : theme.palette.custom.primaryTextGrey,
                      fontWeight: 500,
                    }}
                  >
                    {label}
                  </Box>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>
}

      {
        // (role === '' || role == null || role == undefined) && isSalesLink &&
        <Box sx={{ mt: "auto" }}>
          <List>
            <ListItem>
              <ListItemButton
                onClick={(e) => handleClick(e, "Currency", "")}
                sx={{
                  flexDirection: isMobile ? "row" : "column",
                  alignItems: "center",
                  justifyContent: isMobile ? "flex-start" : "center",
                  color: "inherit",
                  py: 1.5,
                  px: isMobile ? 2 : 0,
                  textAlign: isMobile ? "left" : "center",
                  gap: isMobile ? 1.5 : 0,

                  "aria-label": "Currency",
                  title: "Currency",
                  padding: "0px",
                }}
              >
                <Box
                  // className="new-navbar"
                  sx={{
                    backgroundColor: "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 1,
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={currencyImage(currentCurrency)}
                    alt="Currency"
                    className="icon-size"
                  />
                </Box>

                <Box
                  sx={{
                    fontSize: 13,
                    color: theme.palette.custom.primaryTextGrey,
                    fontWeight: 500,
                  }}
                >
                  Currency (
                  {
                    currenciesWithSymbol.find(
                      (currency) => currency.code === currentCurrency
                    )?.symbol
                  }
                  )
                </Box>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      }
    </Box>
    {loginModal.open && <ClientLogin open={loginModal.open} onClose={loginModal.handleChange} />}
    </>
  );
};

export default DrawerContent;
